import _asyncToGenerator from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator";
import React from "react";
var __jsx = React.createElement;
import _regeneratorRuntime from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/regenerator";
import { Button, TextField } from '@material-ui/core';
import omit from 'lodash/omit';
import { useRouter } from 'next/router';
import { useCallback, useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { AffiliationBlockType, AffiliationOfferType } from '@uno/common-cms';
import Loader from 'components/common/Loader';
import { GradientButton } from 'components/common/material-ui/custom-components';
import { useSiteConfig, useSnackAsyncError } from 'libs/common/hooks';
import { createAffiliation, updateAffiliation } from 'services/networking/affiliation';
import AddSlide from './AddSlide/AddSlide';
import { ButtonContainer, Description, InputContainer, LoaderContainer } from './AffiliationBlockTypeSlideshow.style';
import ProductList from './ProductList/ProductList';
import useAffiliationBlockSlideshow from './hooks/useAffiliationBlockSlideshow';

var AffiliationBlockTypeSlideshow = function AffiliationBlockTypeSlideshow(_ref) {
  var initialLinkData = _ref.initialLinkData,
      onConfirm = _ref.onConfirm;
  var router = useRouter();
  var contentId = router.query.id;

  var _useSiteConfig = useSiteConfig(),
      site = _useSiteConfig.id,
      lang = _useSiteConfig.lang;

  var intl = useIntl();

  var _useSnackAsyncError = useSnackAsyncError(),
      snackAsyncError = _useSnackAsyncError.snackAsyncError;

  var _useAffiliationBlockS = useAffiliationBlockSlideshow(initialLinkData, lang, site),
      selectedProducts = _useAffiliationBlockS.selectedProducts,
      addSelectedProduct = _useAffiliationBlockS.addSelectedProduct,
      editSelectedProduct = _useAffiliationBlockS.editSelectedProduct,
      removeSelectedProduct = _useAffiliationBlockS.removeSelectedProduct,
      retrieveProductsLoading = _useAffiliationBlockS.retrieveProductsLoading;

  var _useState = useState(initialLinkData === null || initialLinkData === void 0 ? void 0 : initialLinkData.title),
      title = _useState[0],
      setTitle = _useState[1];

  var _useState2 = useState((initialLinkData === null || initialLinkData === void 0 ? void 0 : initialLinkData.title) !== undefined),
      isTitleCustomized = _useState2[0],
      setIsTitleCustomized = _useState2[1];

  var _useState3 = useState({
    addSlide: false
  }),
      addSlide = _useState3[0],
      setAddSlide = _useState3[1];

  useEffect(function () {
    setAddSlide({
      addSlide: selectedProducts === undefined || selectedProducts.length === 0
    });
  }, [selectedProducts]);
  useEffect(function () {
    var _selectedProducts$0$n, _selectedProducts$;

    if (selectedProducts === undefined || selectedProducts.length === 0 || isTitleCustomized === true) {
      return;
    }

    setTitle((_selectedProducts$0$n = selectedProducts === null || selectedProducts === void 0 ? void 0 : (_selectedProducts$ = selectedProducts[0]) === null || _selectedProducts$ === void 0 ? void 0 : _selectedProducts$.name) !== null && _selectedProducts$0$n !== void 0 ? _selectedProducts$0$n : '');
  }, [selectedProducts, isTitleCustomized, title]);
  var handleConfirm = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    var products, newBlockData;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (!(selectedProducts === undefined)) {
              _context3.next = 2;
              break;
            }

            return _context3.abrupt("return");

          case 2:
            products = selectedProducts === null || selectedProducts === void 0 ? void 0 : selectedProducts.map(function (product) {
              return omit(product, 'offer');
            });

            newBlockData = function newBlockData(affiliationId) {
              return {
                affiliationId: affiliationId,
                title: title,
                type: AffiliationBlockType.Slideshow,
                products: initialLinkData === null || initialLinkData === void 0 ? void 0 : initialLinkData.products
              };
            };

            if (!((initialLinkData === null || initialLinkData === void 0 ? void 0 : initialLinkData.affiliationId) === undefined)) {
              _context3.next = 8;
              break;
            }

            _context3.next = 7;
            return snackAsyncError({
              messageId: 'affiliation.error.create',
              callback: function () {
                var _callback = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                  var _yield$createAffiliat, affiliationId;

                  return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.next = 2;
                          return createAffiliation(AffiliationOfferType.SINGLE_OFFER, contentId, products);

                        case 2:
                          _yield$createAffiliat = _context.sent;
                          affiliationId = _yield$createAffiliat.affiliationId;
                          onConfirm(newBlockData(affiliationId));

                        case 5:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));

                function callback() {
                  return _callback.apply(this, arguments);
                }

                return callback;
              }(),
              errorCallback: function errorCallback() {
                onConfirm(null);
              }
            });

          case 7:
            return _context3.abrupt("return");

          case 8:
            _context3.next = 10;
            return snackAsyncError({
              messageId: 'affiliation.error.update',
              callback: function () {
                var _callback2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
                  return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          _context2.next = 2;
                          return updateAffiliation(initialLinkData.affiliationId, AffiliationOfferType.SINGLE_OFFER, contentId, products);

                        case 2:
                          onConfirm(newBlockData(initialLinkData.affiliationId));

                        case 3:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2);
                }));

                function callback() {
                  return _callback2.apply(this, arguments);
                }

                return callback;
              }()
            });

          case 10:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  })), [contentId, initialLinkData, onConfirm, selectedProducts, snackAsyncError, title]);

  var onSlideConfirm = function onSlideConfirm(product, productIndex) {
    setAddSlide({
      addSlide: false
    });

    if (productIndex === undefined) {
      addSelectedProduct(product);
    } else {
      editSelectedProduct(productIndex, product);
    }
  };

  var onSlideCancel = function onSlideCancel() {
    setAddSlide({
      addSlide: selectedProducts === undefined || selectedProducts.length === 0
    });
  };

  if (retrieveProductsLoading) {
    return __jsx(LoaderContainer, null, __jsx(Loader, null));
  }

  if (addSlide.addSlide || addSlide.slideIndex !== undefined) {
    return __jsx(AddSlide, {
      products: selectedProducts,
      selectedIndex: addSlide.slideIndex,
      onConfirm: onSlideConfirm,
      onBack: onSlideCancel
    });
  }

  return __jsx(React.Fragment, null, __jsx(FormattedMessage, {
    id: "affiliation-slideshow-modal.description",
    tagName: Description
  }), __jsx(InputContainer, null, __jsx(TextField, {
    id: "affiliation-block-modal-slideshow-title",
    value: title,
    fullWidth: true,
    type: "text",
    onChange: function onChange(event) {
      setTitle(event.target.value);
      setIsTitleCustomized(true);
    },
    label: intl.formatMessage({
      id: 'affiliation-slideshow-modal.title'
    }),
    variant: "outlined"
  })), __jsx(ProductList, {
    products: selectedProducts !== null && selectedProducts !== void 0 ? selectedProducts : [],
    onEditProduct: function onEditProduct(index) {
      return setAddSlide({
        addSlide: addSlide.addSlide,
        slideIndex: index
      });
    },
    onRemoveProduct: removeSelectedProduct
  }), __jsx(ButtonContainer, null, __jsx(Button, {
    variant: "outlined",
    color: "primary",
    onClick: function onClick() {
      return setAddSlide({
        addSlide: true
      });
    }
  }, __jsx(FormattedMessage, {
    id: "affiliation-slideshow-modal.add-product"
  })), __jsx(GradientButton, {
    disabled: selectedProducts === undefined || selectedProducts.length < 2,
    onClick: handleConfirm
  }, __jsx(FormattedMessage, {
    id: "affiliation-slideshow-modal.confirm"
  }))));
};

export default AffiliationBlockTypeSlideshow;